import React, { Fragment } from 'react';
import {
	Container,
	Row,
	Col,
	Button,
	Progress
} from "reactstrap";
import useProjectSteps from '../../../../hooks/useProjectSteps';
import BuildeBlueLogo from "../../assets/builde-logo-blue.png";
import './steps.scss';

function Header({ title, progress }) {
	const projectSteps = useProjectSteps();

    return (
    	<Fragment>
			<nav id="topbar">
				<Container className="builde-cont">
					<Row>
						<Col xs={{ size: 12 }}>
							<div className="cont-topbar d-flex">
								<Button className="btn-back" onClick={() => projectSteps.goPreviousStep()}></Button>
								<h3>{title}</h3>
								<img className='w-25 me-0' src={BuildeBlueLogo} alt="" />
							</div>
						</Col>
					</Row>
				</Container>
			</nav>
	    	<section id="progress-bar">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
	    					<Progress value={progress}></Progress>
		    			</Col>
			    	</Row>
		    	</Container>
	    	</section>
    	</Fragment>
    );
}

export default Header;